var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eic-dashboard" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container",
        staticStyle: { color: "black", width: "90%", "max-width": "100%" },
      },
      [
        _c("div", { staticClass: "filters" }, [
          _c("div", { staticClass: "filter-row" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title",
                },
              ],
              staticClass: "filter",
              attrs: { placeholder: "Title", type: "text" },
              domProps: { value: _vm.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.title = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affiliation,
                  expression: "affiliation",
                },
              ],
              staticClass: "filter",
              attrs: { placeholder: "Affiliation", type: "text" },
              domProps: { value: _vm.affiliation },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.affiliation = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.abstract,
                  expression: "abstract",
                },
              ],
              staticClass: "filter",
              attrs: { placeholder: "Abstract", type: "text" },
              domProps: { value: _vm.abstract },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.abstract = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keywords,
                  expression: "keywords",
                },
              ],
              staticClass: "filter",
              attrs: { placeholder: "Keywords", type: "text" },
              domProps: { value: _vm.keywords },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.keywords = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-row" }, [
            _c(
              "button",
              {
                staticClass: "filter-button",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.filterResults.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Filter Results")]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container table-container",
        staticStyle: { width: "90%", "max-width": "100%" },
      },
      [
        _vm.count
          ? _c("div", { staticClass: "filter-row" }, [
              _c("span", [_vm._v(_vm._s(_vm.count) + " Results")]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-left": "8px" } }, [
                _c("span", {
                  staticClass: "fas fa-angle-double-left",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.left },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    " " + _vm._s(_vm.page) + " / " + _vm._s(_vm.getPages) + " "
                  ),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "fas fa-angle-double-right",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.right },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("table", { staticClass: "table table-striped" }, [
          _vm._m(1),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "tbody",
                [
                  _vm._l(_vm.data, function (author, authorIndex) {
                    return [
                      _c(
                        "tr",
                        { staticStyle: { "background-color": "#EEE" } },
                        [
                          _c("td", [_vm._v(_vm._s(author.articles.length))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(author.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              { attrs: { href: `mailto:${author.email}` } },
                              [_vm._v(_vm._s(author.email))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(_vm._s(author.orcid)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      author.articles.length
                        ? _c(
                            "tr",
                            { staticStyle: { "background-color": "#FFF" } },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v("MS #")]),
                              _vm._v(" "),
                              _c("td", [_vm._v("Title")]),
                              _vm._v(" "),
                              _c("td", [_vm._v("URL")]),
                              _vm._v(" "),
                              _c("td", [_vm._v("Submitted")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(author.articles, function (article, articleIndex) {
                        return _c(
                          "tr",
                          {
                            key: articleIndex,
                            staticStyle: { "background-color": "#FFF" },
                          },
                          [
                            _c("td"),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(article.id))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(article.title))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("a", { attrs: { href: article.html_url } }, [
                                _vm._v(_vm._s(article.doi)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(article.submitted_at))]),
                          ]
                        )
                      }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("tbody", { staticStyle: { "text-align": "center" } }, [
                _vm._m(2),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.data && !_vm.loading
            ? _c("tbody", { staticStyle: { "text-align": "center" } }, [
                _c("td", { attrs: { colspan: "5" } }, [
                  _vm._v("No results to display!"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "container-fluid bg-white mb-5" }, [
        _c("div", { staticClass: "container pl-1 pt-3 pb-3" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.jmirpublications.com",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticStyle: { width: "255px" },
                attrs: { src: "/public/images/JMIR-logo@2x.png" },
              }),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", [_vm._v("Occurrences")]),
      _vm._v(" "),
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Email")]),
      _vm._v(" "),
      _c("th", { attrs: { colspan: "2" } }, [_vm._v("Orcid")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("div", { staticClass: "lds-ellipsis" }, [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }